// extracted by mini-css-extract-plugin
module.exports = {"Form_container":"newNoteForm_Form_container__2BrcH","form_controls":"newNoteForm_form_controls__3eCvF","form":"newNoteForm_form__2UHe-"};